module.exports = __webpack_public_path__ + "img/sceneBack1.cbb656a9.png";